function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useRef, useEffect } from "react";
import { List, Button, Space, Drawer, Modal, notification } from "antd";
import { Receipt } from "react-bootstrap-icons";
import Moment from "react-moment";
import EditBill from "./forms/EditBill";
import DisplayInvoice from "./DisplayInvoice";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import Common from "./includes/Common";
import CashIn from "./forms/CashIn";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var InvoiceList = function InvoiceList(_ref) {
  var list = _ref.list,
    refresh = _ref.refresh,
    loading = _ref.loading,
    reload = _ref.reload,
    _ref$origin = _ref.origin,
    origin = _ref$origin === void 0 ? null : _ref$origin;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    selectedInvoice = _useState2[0],
    setSelectedIonvoice = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showEdit = _useState4[0],
    setShowEdit = _useState4[1];
  var _useState5 = useState(loading),
    _useState6 = _slicedToArray(_useState5, 2),
    dloading = _useState6[0],
    setDloading = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showInvoice = _useState8[0],
    setShowInvoice = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    validationProcessing = _useState0[0],
    setValidationProcessing = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    showCashin = _useState10[0],
    setShowCashin = _useState10[1];
  var ref = useRef();
  var handleValidateInvoice = function handleValidateInvoice(item) {
    setSelectedIonvoice(item);
    setValidationProcessing(true);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmer la validation du devis"
      }),
      content: /*#__PURE__*/_jsx("p", {
        children: "Apr\xE8s validation, une facture sera g\xE9n\xE9r\xE9e pour ce devis"
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "validateinvoice", {
          id: item.id.toString(),
          user_id: Common.currentUser.id
        }).then(function (response) {
          if (response.data.status == 200) {
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
          } else {
            notification.error({
              message: "Echec!",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur!",
            description: "Une erreur est survenue " + error.toString()
          });
        })["finally"](function () {
          setValidationProcessing(false);
        });
      },
      onCancel: function onCancel() {
        setValidationProcessing(false);
      }
    });
  };
  var handleCashin = function handleCashin(item) {
    setSelectedIonvoice(item);
    setShowCashin(true);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(List, {
      dataSource: list,
      itemLayout: "horizontal",
      loading: loading,
      renderItem: function renderItem(item, index) {
        return /*#__PURE__*/_jsx(List.Item, {
          actions: [/*#__PURE__*/_jsx(Button, {
            type: "link",
            onClick: function onClick() {
              setSelectedIonvoice(item);
              setShowInvoice(true);
            },
            children: /*#__PURE__*/_jsx("b", {
              children: "OUVRIR"
            })
          }), /*#__PURE__*/_jsx(Button, {
            type: "link",
            onClick: function onClick() {
              setSelectedIonvoice(item);
              setShowEdit(true);
            },
            children: /*#__PURE__*/_jsx("b", {
              children: "MODIFIER"
            })
          }), item.status == 0 && /*#__PURE__*/_jsx(Button, {
            type: "link",
            loading: validationProcessing,
            onClick: function onClick() {
              handleValidateInvoice(item);
            },
            children: /*#__PURE__*/_jsx("b", {
              children: "CONFIRMER"
            })
          }), origin == "accountant" && /*#__PURE__*/_jsx(Button, {
            type: "link",
            onClick: function onClick() {
              handleCashin(item);
            },
            children: /*#__PURE__*/_jsx("b", {
              children: "ENCAISSER"
            })
          })],
          children: /*#__PURE__*/_jsx(List.Item.Meta, {
            avatar: /*#__PURE__*/_jsx(Receipt, {
              size: 16
            }),
            title: item.lead != null ? /*#__PURE__*/_jsx("b", {
              children: item.lead.name
            }) : /*#__PURE__*/_jsx("b", {
              children: "PROSPET INTROUVABLE"
            }),
            description: /*#__PURE__*/_jsxs(Space, {
              children: [/*#__PURE__*/_jsxs("span", {
                children: [/*#__PURE__*/_jsx("b", {
                  children: "Montant Total: "
                }), item.total_amount.toLocaleString("Fr")]
              }), /*#__PURE__*/_jsxs("span", {
                children: [/*#__PURE__*/_jsx("b", {
                  children: "Reste \xE0 payer: "
                }), (item.total_amount - item.paid_amount).toLocaleString("Fr"), " GNF"]
              }), /*#__PURE__*/_jsxs("span", {
                children: [/*#__PURE__*/_jsx("b", {
                  children: "Date: "
                }), /*#__PURE__*/_jsx(Moment, {
                  date: item.created_at,
                  format: "DD/MM/YYYY"
                })]
              })]
            })
          })
        });
      }
    }), selectedInvoice && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "MODIFIER LE DEVIS"
        }),
        width: "80%",
        open: showEdit,
        onClose: function onClose() {
          setShowEdit(false);
        },
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx(EditBill, {
          bill: selectedInvoice,
          handler: function handler() {
            setShowEdit(false);
            notification.success({
              message: "Ok!",
              description: "Le devis à été modifié"
            });
          }
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "DETAILS DEVIS"
        }),
        width: "80%",
        open: showInvoice,
        onClose: function onClose() {
          setShowInvoice(false);
        },
        destroyOnClose: true,
        extra: /*#__PURE__*/_jsxs(Space, {
          children: [/*#__PURE__*/_jsx(Button, {
            type: "primary",
            disabled: selectedInvoice.status == 1,
            loading: validationProcessing,
            onClick: function onClick() {
              handleValidateInvoice(selectedInvoice);
            },
            children: /*#__PURE__*/_jsx("b", {
              children: "CONFIRMER"
            })
          }), /*#__PURE__*/_jsx(ReactToPrint, {
            content: function content() {
              return ref.current;
            },
            children: /*#__PURE__*/_jsx(PrintContextConsumer, {
              children: function children(_ref2) {
                var handlePrint = _ref2.handlePrint;
                return /*#__PURE__*/_jsx(Button, {
                  onClick: handlePrint,
                  type: "ghost",
                  children: /*#__PURE__*/_jsx("b", {
                    children: "IMPRIMER"
                  })
                });
              }
            })
          })]
        }),
        children: /*#__PURE__*/_jsx(DisplayInvoice, {
          ref: ref,
          invoice: selectedInvoice
        })
      }), /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsx("b", {
          children: "ENCAISSER"
        }),
        width: "550px",
        open: showCashin,
        onCancel: function onCancel() {
          setShowCashin(false);
        },
        destroyOnClose: true,
        footer: null,
        children: /*#__PURE__*/_jsx(CashIn, {
          invoice: selectedInvoice,
          handler: function handler() {
            setShowCashin(false);
            notification.success({
              message: "Encaissement enregistré"
            });
            reload();
          }
        })
      })]
    })]
  });
};
export default InvoiceList;